export default __webpack_public_path__ + "static/home-page-bio-3-804ba7510136b684223fb4c4c3928b07.webp";